import styled from '@emotion/styled';

export const LabelContainer = styled.label`
    font-family: ${({ theme }): string => theme.font.family};
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
    color: #666666;
    display: flex;
    margin-bottom: 8px;
`;

export const IconContainer = styled.span`
    margin-left: 4px;
    padding-top: 2px;
`;

export const TooltipContent = styled.div`
    max-width: 400px;
    text-align: left;
`;

export const TooltipTitle = styled.div`
    font-weight: bold;
    margin-bottom: 8px;
    font-size: 14px;
`;

export const TooltipDescription = styled.div`
    margin-bottom: 8px;
    font-size: 13px;
    line-height: 1.4;
`;

export const TooltipExample = styled.div`
    font-size: 13px;
    line-height: 1.4;
    margin-top: 8px;

    strong {
        font-weight: bold;
    }
`;
